export default __webpack_public_path__ + "static/media/sb.c1a9855a.jpg";